import { Section } from "../components/sections/TextSection";
import { borderProps, commonProps } from "./commonPropInfo";

export const ImageConfig: Section = {
    row: 0,
    col: 0,
    name: 'Image',
    type: 'image',
    id: '2',
    selected: false,
    height: 60,
    width: 60,
    textContent: "Some Text",
    rowCount: 10,
    colCount: 10,
    x: 0,
    y: 0,
    isLocked: false,
    propInfo: [
        {
            name: "Opacity",
            inputType: 'decimal',
            binding: 'style.opacity',
            value: 1,
            label: 'Opacity',
        },  
        {
            name: "Fit Type",
            inputType: 'dropdown',
            options: [
                { label: 'Cover', value: 'cover' },
                { label: 'Contain', value: 'contain' },
                { label: 'Fill', value: 'fill' },
                { label: 'None', value: 'none' },
                { label: 'Scale Down', value: 'scale-down' },
            ],
            binding: 'style.objectFit',
            value: 'cover',
            label: 'Background Image',
        },
        {
            name: "backGroundImage",
            inputType: 'file',
            binding: 'src',
            value: '',
            label: 'Image',
        },
        ...commonProps,
        ...borderProps

    ]
};
